import Organization from "../../models/Organization"

export default {
  data() {
    return {
      loading: false,
      showOrganizationDialog: false,
      organization: null,
      organizations: [],
    }
  },

  methods: {
    async search() {
      // don't push all organizations at once or the DOM rendering may block the
      // main thread for several seconds in extreme cases, fill it in chunks at
      // regular intervals instead:
      const fillOrganizationsInChunk = (organizations, index) => {
        let stop = Math.min(index + 10, organizations.length)
        for (; index < stop; index++) {
          this.organizations.push(organizations[index])
        }
        if (index < organizations.length) {
          this.timer = setTimeout(() => fillOrganizationsInChunk(organizations, index), 50)
        }
      }

      // prepare to display loading dialog:
      const timer = setTimeout(() => this.loading = true, 100)

      // clear any previous chunk filling:
      if (this.timer) clearTimeout(this.timer)
      this.organizations.length = 0

      try {
        // load:
        const organizations = await Organization.tree()
        fillOrganizationsInChunk(organizations || [], 0)
      } finally {
        // hide loading dialog:
        clearTimeout(timer)
        this.loading = false
      }
    },

    async refresh() {
      const timer = setTimeout(() => this.loading = true, 100)
      await Organization.reload()
      this.search()
      clearTimeout(timer)
    },
  },

  mounted() {
    this.search()
  },

  destroyed() {
    // stop filling organizations when leaving the page:
    if (this.timer) clearTimeout(this.timer)
  }
}
